import { ApiMethodDeclaration } from '..';

type ParamsData = {
    status?: 'new' | 'ok' | 'bad';
    adminEmail?: string;
    entityType?: 'attraction' | 'person' | 'route' | 'quest';
    limit?: number;
    offset?: number;
};

type ReviewItem = {
    id: number;
    adminEmail: string;
    entityType: 'attraction' | 'person' | 'route' | 'quest';
    entityId: number;
    entityTitle: string;
    locale: string | null;
    fieldKey: string;
    oldValue: string | null;
    newValue: string | null;
    status: 'new' | 'ok' | 'bad';
    createdAt: string | Date;
};

type ResponseData = {
    total: number;
    items: ReviewItem[];
};

export const list: ApiMethodDeclaration<ParamsData, ResponseData> = (params) => ({
    url: '/admin/content-reviews',
    method: 'GET',
    params: {
        status: params?.status,
        adminEmail: params?.adminEmail,
        entityType: params?.entityType,
        limit: params?.limit,
        offset: params?.offset,
    },
});
